import { FC, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { IDiscountPageProps } from './types';

import { ItemsWithoutFilters } from '../../components';

import { PageWrapperWithCommonBlocks } from 'src/components';
import { removeCurrentData, saveCurrentPaginationPage } from 'src/models';
import { getDiscountItems } from '~utils';

export const DiscountPage: FC<IDiscountPageProps> = ({ className = '', ...rest }) => {
  const { t } = useTranslation();

  useEffect(() => {
    removeCurrentData();
    saveCurrentPaginationPage(1);
  }, []);

  return (
    <PageWrapperWithCommonBlocks className={className} {...rest}>
      <ItemsWithoutFilters title={t('items.discount-title')} fetchFn={getDiscountItems} />
    </PageWrapperWithCommonBlocks>
  );
};
